import getBasePath from '../../functions/api-resource';

const basePath = getBasePath('usuario', 'sso/role');

const roleActions = {
  listar: { method: 'GET', url: `${basePath}` },
};

export default (resource) => resource(`${basePath}`, {}, roleActions);
